import React, { useEffect, useState } from "react";

import { InputLabel, MenuItem, Select, Grid, Box, TextField, IconButton, Button  } from "@mui/material";
import PropTypes from "prop-types";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DatePicker } from "@material-ui/pickers";
import DinercapDateIcon from "../../utils/DinercapDateIcon";
import { useSolicitud } from "../../../context/SolicitudContext";
import { inputColor, inputVariant } from "../../../settings/inputConfig";
import { useStyle } from "../../../context/StyleContext";
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';

export default function FormatoReporteCredDialog(props) {
    const { classes } = useStyle();
    const { onClose, open } = props;
    const { listaFinancieras, formFiltroReporteCredito, handleChangeFormFiltroDate, handleListaFinancieras, handleChangeFormNombreBuro,
        finacieraSeleccionadaSelect, handleChangeFinancieraSeleccionadaSelect, handleGetReporteCredExcel, loading
    } = useSolicitud();
    const { txtFechaIni, txtFechaFin, txtNombreBuro } = formFiltroReporteCredito;

    const handleClose = () => {
        onClose();
    };

    useEffect(() => {
        handleListaFinancieras();
    }, []);

    //useEffect(() => {
    //}, [finacieraSeleccionadaSelect.iIdFinanciera]);

    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" maxWidth={false}
        PaperProps={{
            sx: {
                width: '570px',
                height: '65vh',       // 👈 alto fijo (en este caso 80% de la ventana)
                maxHeight: '95vh',    // 👈 para limitarlo
            }
        }}open={open}>
            <DialogTitle id="simple-dialog-title">Filtros reporte de crédito
                <IconButton
                    aria-label="cerrar"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <Box sx={{ maxWidth: 500, mx: 'auto' }}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <DatePicker
                            name="txtFechaIni"
                            label={txtFechaIni.label}
                            value={txtFechaIni.value}
                            onChange={(date) => handleChangeFormFiltroDate(date, "txtFechaIni")}
                            InputProps={{ endAdornment: <DinercapDateIcon /> }}
                            inputVariant={inputVariant}
                            format="dd/MM/yyyy"
                            color={inputColor}
                            variant="inline"
                            fullWidth
                            autoOk={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DatePicker
                            name="txtFechaFin"
                            label={txtFechaFin.label}
                            value={txtFechaFin.value}
                            onChange={(date) => handleChangeFormFiltroDate(date, "txtFechaFin")}
                            InputProps={{ endAdornment: <DinercapDateIcon /> }}
                            inputVariant={inputVariant}
                            format="dd/MM/yyyy"
                            color={inputColor}
                            variant="inline"
                            fullWidth
                            autoOk={true}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel>
                            <i className="fa fa-filter"></i>&nbsp;<b>Financiera:</b>
                        </InputLabel>
                        {listaFinancieras.length > 0 && (
                            <Select
                                variant="filled"
                                className={classes.fControl}
                                labelId="finaciera-select-label"
                                id="finaciera-select"
                                value={finacieraSeleccionadaSelect.iIdFinanciera}
                                label="Financiera"
                                fullWidth
                                onChange={(e) => handleChangeFinancieraSeleccionadaSelect(e.target.value)}
                            >
                                <MenuItem value={0} disabled>
                                    -- Selecciona una financiera --
                                </MenuItem>

                                {listaFinancieras.map((financiera) => (
                                    <MenuItem key={financiera.id} value={financiera.id}>
                                        {financiera.text}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            name="txtNombreBuro"
                            label={txtNombreBuro.label}
                            value={txtNombreBuro.value}
                            variant={inputVariant}
                            color={inputColor}
                            onChange={handleChangeFormNombreBuro}
                            fullWidth
                            autoFocus
                            autoComplete="off"
                            className="mb-2"
                            disabled
                        />
                    </Grid>
                </Grid>
                <Box display="flex" justifyContent="center" mt={2}>
                    <Button variant="contained" 
                            onClick={handleGetReporteCredExcel} 
                            color="primary" 
                            disabled={loading}
                    >
                        Generar
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
}

FormatoReporteCredDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.number.isRequired,
};